__webpack_require__.p = "/sparrow-short-courses-view/";